/* eslint-disable react/no-did-update-set-state */
import _ from 'lodash';
import React, { Component } from 'react';
import TableGrid from './TableGrid';
import Input from './InputBorderless';
import Button from './StyledButton';
import { HelpText } from './typography';
import CenterFlex from './CenterFlex';

class SpottingGroupTermPreview extends Component {
  constructor(props) {
    super(props);
    this.state = { newKeyword: '', keywords: _.get(props, 'keywords', []) };
    this.debouncedOnChange = _.debounce(this.onChange, 1000);
  }

  updateField(term, rowIndex) {
    const keywords = [...this.state.keywords];
    keywords[rowIndex] = term;
    this.setState({ keywords }, () => this.debouncedOnChange());
  }

  onChange() {
    this.props.onChange(_([...this.state.keywords, this.state.newKeyword])
      .compact()
      .sortBy()
      .uniq()
      .value()
      .join('\n'));
  }

  termRow(term, rowIndex) {
    return (
      <tr key={rowIndex}>
        <td>
          <Input
            type="text"
            id={`keyword-${rowIndex}`}
            value={term}
            onChange={event => this.updateField(event.target.value, rowIndex)}
            onKeyPress={event => this.termFieldPress(event, rowIndex)}
          />
        </td>
      </tr>
    );
  }

  termFieldPress(event, index) {
    if (event.key === 'Enter') {
      const nextIndex = index + 1;
      const id = `keyword-${nextIndex}`;

      const nextElement = document.getElementById(id);
      if (nextElement) {
        nextElement.focus();
      } else {
        const ele = document.getElementById('keyword-new');
        if (ele) ele.focus();
      }
    }
  }
  componentDidUpdate(prevProps) {
    if (_.isEqual(prevProps.keywords, this.props.keywords)) return;
    const propKWset = new Set(this.props.keywords);
    const stateKWset = new Set(this.state.keywords);
    propKWset.add('');
    stateKWset.add('');
    stateKWset.add(this.state.newKeyword);
    if (!_.isEqual(propKWset, stateKWset)) {
      // assume a reset or import
      this.setState({ newKeyword: '', keywords: [...this.props.keywords] });
    }
  }

  saveNewTerm() {
    const keywords = [...this.state.keywords, this.state.newKeyword];
    this.setState({ newKeyword: '', keywords });
  }

  newTermKeyPress(event) {
    if (event.key === 'Enter') {
      this.saveNewTerm();
      requestAnimationFrame(() => {
        document.getElementById('keyword-new').focus();
      });
    }
  }

  newTermRow(rowIndex) {
    return (
      <tr key={rowIndex}>
        <td><Input
          type="text"
          id="keyword-new"
          autoComplete="off"
          placeholder="keyword or phrase"
          value={this.state.newKeyword}
          onKeyPress={event => this.newTermKeyPress(event)}
          onChange={event => this.setState(
            { newKeyword: event.target.value || '' },
            () => this.debouncedOnChange(),
          )}
        />
        </td>
      </tr>
    );
  }

  render() {
    return (
      <TableGrid style={({ width: '100%' })}>
        <thead>
          <tr>
            <th style={({ minWidth: 80 })}>Keyword</th>
          </tr>
        </thead>
        <tbody>
          {(this.state.keywords).map(((term, rowIndex) => this.termRow(term, rowIndex)))}
          {this.newTermRow(this.state.keywords.length)}
          <tr>
            <td>
              <CenterFlex>
                <HelpText style={({ marginRight: '1rem' })}>
                  Use the <b>Enter</b> Key in last keyword field to
                </HelpText>
                <Button size="small" onClick={() => this.saveNewTerm()}>
                  Add A Row
                </Button>
              </CenterFlex>
            </td>
          </tr>
        </tbody>
      </TableGrid>
    );
  }
}

export default SpottingGroupTermPreview;
